import type { ShueishaIdAuthType } from '@/features/account/types';
import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

type GetShueishaIdAuthParamResponse = APIResponse<{
  codeChallenge: string;
}>;

export const getShueishaIdAuthParam = async (type: ShueishaIdAuthType, callbackUrl?: string) => {
  return await http<GetShueishaIdAuthParamResponse>('/user/v1/shueisha-id/auth-param', {
    method: 'GET',
    query: {
      oem_service_id: process.env.NEXT_PUBLIC_SERVICE_ID,
      type: type,
      callback_url: callbackUrl,
    },
  });
};
